import { Box, makeStyles } from "@material-ui/core";
import Arrow from "./assets/arrow.svg";
import ConnectedAdressForm from "./ConnectedAddressForm";

import { Body, BodyLarge, H4 } from "components/design-system/atoms/Typography";
import Button from "components/design-system/atoms/Button";
import LowImpactPictoGreen from "components/localOffer/assets/lowImpactPictoGreen.svg";
import InformationDrawer from "components/design-system/molecules/InformationDrawer/InformationDrawer";
import LocalOfferDrawerContent from "./LocalOfferBlockDrawerContent";
export default function LocalOfferTurquoiseBlock({ autoFocusField, addCatalogsToRefinementList }) {
  const classes = useStyle();

  return (
    <Box className={classes.container} id="local-offer-top">
      <Box position="absolute" right={100}>
        <Arrow />
      </Box>
      <Box padding={5}>
        <Box className={classes.insideBox}>
          <Box>
            <H4 className={classes.title}>
              Choisir le local, c&apos;est l&apos;idéal
              <br />
            </H4>
            <BodyLarge mt={2}>
              Des appareils expédiés en 24h,
              <br />
              reconditionnés près de chez vous
            </BodyLarge>
          </Box>
          <Box width="58%" zIndex={2}>
            <Box>
              <ConnectedAdressForm
                id="local-block"
                autoFocusField={autoFocusField}
                addCatalogsToRefinementList={addCatalogsToRefinementList}
                disabled={false}
              >
                <Box ml={1}>
                  <Button type="submit" version="green" size="large">
                    <span style={{ fontWeight: 500 }}>Filtrer</span>
                  </Button>
                </Box>
              </ConnectedAdressForm>
            </Box>
            <Box mt={2} display="flex">
              <LowImpactPictoGreen />
              <Box zIndex={2} ml={2}>
                <InformationDrawer
                  anchor="right"
                  width="470px"
                  title="Disponibles près de chez vous"
                  button={
                    <Body color="secondary.main">
                      <u>En savoir +</u>
                    </Body>
                  }
                >
                  {() => <LocalOfferDrawerContent />}
                </InformationDrawer>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    justifyContent: "space-between",

    background: theme.palette.green,
    borderRadius: 12,
  },
  insideBox: {
    justifyContent: "space-between",
    alignItems: "center",
    color: theme.palette.secondary.main,
    display: "flex",
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
  },
}));
